import React from 'react';
import { Input } from 'antd';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import cn from 'classnames';

import './style.scss';

export const allowDigitLength = (inputObj, limit = 9) => {
  const { value } = inputObj;
  if (value.length <= limit) return inputObj;
};

const NumberInput = ({
  thousandSeparator,
  decimalSeparator,
  decimalScale,
  prefix,
  prefixClass,
  ...rest
}) => {
  return (
    <div id="my-input-v2">
      {prefix && (
        <div
          className={cn('number-input-prefix-custom', prefixClass, {
            'number-input-prefix-custom-disabled': rest.disabled,
          })}
        >
          <span>{prefix}</span>
        </div>
      )}
      <NumberFormat
        {...rest}
        className={cn('input-custom', { 'has-prefix': !!prefix }, prefixClass)}
        customInput={Input}
        thousandSeparator={thousandSeparator}
        decimalSeparator={decimalSeparator}
        decimalScale={decimalScale}
      />
    </div>
  );
};

NumberInput.propTypes = {
  thousandSeparator: PropTypes.bool,
  decimalSeparator: PropTypes.string,
  decimalScale: PropTypes.number,
};

NumberInput.defaultProps = {
  thousandSeparator: true,
  decimalSeparator: '.',
  decimalScale: 2,
};

export default NumberInput;
